module.exports = __webpack_public_path__ + "img/running.8123b886.png";